import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { updateDataSearchTaiKhoanBank } from "../../../actions/TichHopBank/DanhSachTaiKhoanBank";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { DanhSachBankConst } from "../../../constants/danhSachTaiSanConst";

export const SearchBarDesktop = ({ onSearch }) => {
  const dispatch = useDispatch();

  const dataSearch = useSelector((state) => state.dataSearchTaiKhoanBank);

  const updateTextValue = (field) => (e) => {
    updateState(field, e.target.value);
  };

  const updateState = (field, text) => {
    dispatch(
      updateDataSearchTaiKhoanBank({
        ...dataSearch,
        [field]: text,
      })
    );
  };

  const [dataBankCombo, setDataBankCombo] = useState(DanhSachBankConst.Bank);
  useEffect(() => {}, []);
  return (
    <>
      <div className="search-new hidden-mobile-main show-table-main">
        <div className="input-sm-new input-new-18">
          <label className="font-color-default font-bold">
            Số tài khoản, họ và tên
          </label>
          <input
            placeholder="Số tài khoản, họ và tên"
            type="text"
            className="form-control input-sm"
            value={dataSearch.tieude}
            onChange={updateTextValue("tieude")}
          ></input>
        </div>
        <div className="input-sm-new input-new-18">
          <label className="font-color-default font-bold">Ngân hàng</label>
          <select
            class="form-control input-sm"
            value={dataSearch.sMaNganHang}
            onChange={updateTextValue("sMaNganHang")}
          >
            <option value="">Tất cả</option>
            {dataBankCombo &&
              dataBankCombo.map((item, idx) => (
                <option key={"comboBank" + idx} value={item.value}>
                  {item.label}
                </option>
              ))}
          </select>
        </div>
        <div className="input-sm-new input-new-18">
          <label className="font-color-default font-bold">Trạng thái</label>
          <select
            class="form-control input-sm"
            value={dataSearch.isKhoa}
            onChange={updateTextValue("isKhoa")}
          >
            <option value="">Tất cả</option>
            <option value="0">Không khóa</option>
            <option value="1">Đã khóa</option>
          </select>
        </div>
        <div className="input-sm-new input-new-18 search-main-new">
          <button
            type="submit"
            className="btn btn-info-new btn-seach-ds"
            onClick={onSearch}
          >
            <i className="la la-search"></i>
            <span> &nbsp; Tìm kiếm</span>
          </button>
        </div>
      </div>
    </>
  );
};
